import { addClass, detach, EventHandler, isNullOrUndefined, Ajax } from '@syncfusion/ej2-base';
import { Browser, closest, removeClass, isNullOrUndefined as isNOU } from '@syncfusion/ej2-base';
import * as events from '../base/constant';
import * as classes from '../base/classes';
import { CLS_AUD_FOCUS } from '../../common/constant';
import { Uploader } from '@syncfusion/ej2-inputs';
import { Button } from '@syncfusion/ej2-buttons';
import { RenderType } from '../base/enum';
import { dispatchEvent, hasClass } from '../base/util';
import { isIDevice, convertToBlob } from '../../common/util';
import { AudioCommand } from '../../editor-manager/plugin/audio';
import * as EVENTS from './../../common/constant';
/**
 * `Audio` module is used to handle audio actions.
 */
export class Audio {
    constructor(parent, serviceLocator) {
        this.isAudioUploaded = false;
        this.isAllowedTypes = true;
        this.deletedAudio = [];
        this.parent = parent;
        this.rteID = parent.element.id;
        this.i10n = serviceLocator.getService('rteLocale');
        this.rendererFactory = serviceLocator.getService('rendererFactory');
        this.dialogRenderObj = serviceLocator.getService('dialogRenderObject');
        this.popupUploaderObj = serviceLocator.getService('popupUploaderObject');
        this.addEventListener();
        this.onDocumentClickBoundFn = this.onDocumentClick.bind(this);
        this.inputUrlHandler = this.onInputUrl.bind(this);
        this.isDestroyed = false;
    }
    addEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.on(events.keyDown, this.onKeyDown, this);
        this.parent.on(events.keyUp, this.onKeyUp, this);
        this.parent.on(events.insertAudio, this.insertingAudio, this);
        this.parent.on(events.initialEnd, this.afterRender, this);
        this.parent.on(events.dynamicModule, this.afterRender, this);
        this.parent.on(events.showAudioDialog, this.showDialog, this);
        this.parent.on(events.closeAudioDialog, this.closeDialog, this);
        this.parent.on(events.audioToolbarAction, this.onToolbarAction, this);
        this.parent.on(events.dropDownSelect, this.alignmentSelect, this);
        this.parent.on(events.audioDelete, this.deleteAudio, this);
        this.parent.on(events.editAreaClick, this.editAreaClickHandler, this);
        this.parent.on(events.insertCompleted, this.showAudioQuickToolbar, this);
        this.parent.on(events.destroy, this.destroy, this);
        this.parent.on(events.iframeMouseDown, this.closeDialog, this);
        this.parent.on(events.bindOnEnd, this.bindOnEnd, this);
        this.parent.on(events.modelChanged, this.onPropertyChanged, this);
    }
    removeEventListener() {
        this.parent.off(events.keyDown, this.onKeyDown);
        this.parent.off(events.keyUp, this.onKeyUp);
        this.parent.off(events.insertAudio, this.insertingAudio);
        this.parent.off(events.initialEnd, this.afterRender);
        this.parent.off(events.dynamicModule, this.afterRender);
        this.parent.off(events.showAudioDialog, this.showDialog);
        this.parent.off(events.closeAudioDialog, this.closeDialog);
        this.parent.off(events.bindOnEnd, this.bindOnEnd);
        this.parent.off(events.audioToolbarAction, this.onToolbarAction);
        this.parent.off(events.dropDownSelect, this.alignmentSelect);
        this.parent.off(events.audioDelete, this.deleteAudio);
        this.parent.off(events.editAreaClick, this.editAreaClickHandler);
        this.parent.off(events.insertCompleted, this.showAudioQuickToolbar);
        this.parent.off(events.destroy, this.destroy);
        this.parent.off(events.iframeMouseDown, this.closeDialog);
        this.parent.off(EVENTS.touchStart, this.touchStart);
        this.parent.off(EVENTS.touchEnd, this.audioClick);
        this.parent.off(EVENTS.dropEvent, this.dragDrop);
        this.parent.off(EVENTS.dragEnter, this.dragEnter);
        this.parent.off(EVENTS.dragOver, this.dragOver);
        this.parent.off(events.modelChanged, this.onPropertyChanged);
        if (!isNullOrUndefined(this.contentModule)) {
            this.parent.element.ownerDocument.removeEventListener('mousedown', this.onDocumentClickBoundFn);
        }
    }
    bindOnEnd() {
        if (!this.parent.formatter.editorManager.audioObj) {
            this.parent.formatter.editorManager.audioObj = new AudioCommand(this.parent.formatter.editorManager);
        }
    }
    afterRender() {
        this.contentModule = this.rendererFactory.getRenderer(RenderType.Content);
        const dropElement = this.parent.iframeSettings.enable ?
            this.parent.inputElement.ownerDocument : this.parent.inputElement;
        this.parent.on(EVENTS.dropEvent, this.dragDrop, this);
        this.parent.on(EVENTS.dragEnter, this.dragEnter, this);
        this.parent.on(EVENTS.dragOver, this.dragOver, this);
        this.parent.on(EVENTS.touchStart, this.touchStart, this);
        this.parent.on(EVENTS.touchEnd, this.audioClick, this);
        if (!this.parent.readonly) {
            this.parent.element.ownerDocument.addEventListener('mousedown', this.onDocumentClickBoundFn);
        }
    }
    onPropertyChanged(e) {
        for (const prop of Object.keys(e.newProp)) {
            if (prop === 'readonly') {
                // When readonly is enabled, remove the mousedown listener from the document
                if (this.parent.readonly) {
                    this.parent.element.ownerDocument.removeEventListener('mousedown', this.onDocumentClickBoundFn);
                }
                else {
                    // Reattach when readonly is disabled
                    this.parent.element.ownerDocument.addEventListener('mousedown', this.onDocumentClickBoundFn);
                }
            }
        }
    }
    checkAudioBack(range) {
        if (range.startContainer.nodeName === '#text' && range.startOffset === 0 &&
            !isNOU(range.startContainer.previousSibling) && this.isAudioElem(range.startContainer.previousSibling)) {
            this.deletedAudio.push(range.startContainer.previousSibling);
        }
        else if (range.startContainer.nodeName !== '#text' && !isNOU(range.startContainer.childNodes[range.startOffset - 1]) &&
            this.isAudioElem(range.startContainer.childNodes[range.startOffset - 1])) {
            this.deletedAudio.push(range.startContainer.childNodes[range.startOffset - 1]);
        }
    }
    checkAudioDel(range) {
        if (range.startContainer.nodeName === '#text' && range.startOffset === range.startContainer.textContent.length &&
            !isNOU(range.startContainer.nextSibling) && range.startContainer.nextSibling.nodeName === 'AUDIO') {
            this.deletedAudio.push(range.startContainer.nextSibling);
        }
        else if (range.startContainer.nodeName !== '#text' && !isNOU(range.startContainer.childNodes[range.startOffset]) &&
            this.isAudioElem(range.startContainer.childNodes[range.startOffset])) {
            this.deletedAudio.push(range.startContainer.childNodes[range.startOffset]);
        }
    }
    undoStack(args) {
        if ((args.subCommand.toLowerCase() === 'undo' || args.subCommand.toLowerCase() === 'redo') && this.parent.editorMode === 'HTML') {
            for (let i = 0; i < this.parent.formatter.getUndoRedoStack().length; i++) {
                const temp = this.parent.createElement('div');
                const contentElem = this.parent.formatter.getUndoRedoStack()[i].text;
                temp.appendChild(contentElem.cloneNode(true));
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    touchStart(e, ele) {
        if (this.parent.readonly) {
            return;
        }
        this.prevSelectedAudEle = this.audEle;
    }
    onToolbarAction(args) {
        if (isIDevice()) {
            this.parent.notify(events.selectionRestore, {});
        }
        const item = args.args.item;
        switch (item.subCommand) {
            case 'AudioReplace':
                this.parent.notify(events.insertAudio, args);
                break;
            case 'AudioRemove':
                this.parent.notify(events.audioDelete, args);
                break;
        }
    }
    // eslint-disable-next-line
    onKeyUp(event) {
        if (!isNOU(this.deletedAudio) && this.deletedAudio.length > 0) {
            for (let i = 0; i < this.deletedAudio.length; i++) {
                const elem = this.deletedAudio[i];
                const srcElem = elem.tagName === 'SOURCE' ? elem : elem.querySelector('source');
                const args = {
                    element: this.deletedAudio[i].querySelector('audio'),
                    src: srcElem.getAttribute('src')
                };
                this.parent.trigger(events.afterMediaDelete, args);
            }
        }
    }
    onKeyDown(event) {
        const originalEvent = event.args;
        let range;
        let save;
        let selectNodeEle;
        let selectParentEle;
        this.deletedAudio = [];
        let isCursor;
        const keyCodeValues = [27, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123,
            44, 45, 9, 16, 17, 18, 19, 20, 33, 34, 35, 36, 37, 38, 39, 40, 91, 92, 93, 144, 145, 182, 183];
        if (this.parent.editorMode === 'HTML') {
            range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            isCursor = range.startContainer === range.endContainer && range.startOffset === range.endOffset;
        }
        if (!isCursor && this.parent.editorMode === 'HTML' && keyCodeValues.indexOf(originalEvent.which) < 0) {
            const nodes = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
            for (let i = 0; i < nodes.length; i++) {
                if (this.isAudioElem(nodes[i])) {
                    this.deletedAudio.push(nodes[i]);
                }
            }
        }
        if (this.parent.editorMode === 'HTML' && ((originalEvent.which === 8 && originalEvent.code === 'Backspace') ||
            (originalEvent.which === 46 && originalEvent.code === 'Delete'))) {
            const isCursor = range.startContainer === range.endContainer && range.startOffset === range.endOffset;
            if ((originalEvent.which === 8 && originalEvent.code === 'Backspace' && isCursor)) {
                this.checkAudioBack(range);
            }
            else if ((originalEvent.which === 46 && originalEvent.code === 'Delete' && isCursor)) {
                this.checkAudioDel(range);
            }
        }
        if (!isNullOrUndefined(this.parent.formatter.editorManager.nodeSelection) &&
            originalEvent.code !== 'KeyK') {
            range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            selectNodeEle = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
            selectParentEle = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
        }
        if (originalEvent.ctrlKey && (originalEvent.keyCode === 89 || originalEvent.keyCode === 90)) {
            this.undoStack({ subCommand: (originalEvent.keyCode === 90 ? 'undo' : 'redo') });
        }
        if (originalEvent.keyCode === 8 || originalEvent.keyCode === 46) {
            if (selectNodeEle && selectNodeEle[0]) {
                // Is Audio element selected to delete
                const isAudioSelected = this.isAudioElem(selectNodeEle[0]);
                // Is Delete Key is pressed to remove audio
                const isAudioDeleteKeyPress = originalEvent.keyCode === 46 &&
                    (selectNodeEle[0].nextSibling &&
                        this.isAudioElem(selectNodeEle[0].nextSibling) &&
                        (range.startOffset === range.endOffset) &&
                        (range.startContainer.textContent.length === range.startOffset));
                // Is Backspace key is pressed to remove audio
                const isAudioBackSpaceKeyPress = originalEvent.keyCode === 8 &&
                    (selectNodeEle[0].previousSibling &&
                        this.isAudioElem(selectNodeEle[0].previousSibling) &&
                        (range.startOffset === range.endOffset) && range.startOffset === 0);
                if ((isAudioSelected || isAudioBackSpaceKeyPress || isAudioDeleteKeyPress)) {
                    if (!isNullOrUndefined(this.parent.formatter.editorManager.nodeSelection)) {
                        save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
                    }
                    originalEvent.preventDefault();
                    const event = {
                        selectNode: selectNodeEle, selection: save, selectParent: selectParentEle,
                        args: {
                            item: { command: 'Audios', subCommand: 'AudioRemove' },
                            originalEvent: originalEvent
                        }
                    };
                    this.deleteAudio(event, originalEvent.keyCode);
                }
            }
        }
        this.isAudioRemoved = false;
        switch (originalEvent.action) {
            case 'escape':
                if (!isNullOrUndefined(this.dialogObj)) {
                    this.dialogObj.close();
                }
                break;
            case 'backspace':
            case 'delete':
                for (let i = 0; i < this.deletedAudio.length; i++) {
                    const src = this.deletedAudio[i].src;
                    if (!isNullOrUndefined(src) && src !== '') {
                        this.audioRemovePost(src);
                    }
                }
                if (this.parent.editorMode !== 'Markdown' && range.startContainer === range.endContainer && range.startOffset === range.endOffset) {
                    if (range.startContainer.nodeType === 3) {
                        if (originalEvent.code === 'Backspace') {
                            if (range.startContainer.previousElementSibling && range.startOffset === 0 &&
                                range.startContainer.previousElementSibling.classList.contains(classes.CLS_AUDIOWRAP)) {
                                detach(range.startContainer.previousElementSibling);
                                this.isAudioRemoved = true;
                            }
                        }
                        else {
                            if (range.startContainer.nextElementSibling &&
                                range.endContainer.textContent.length === range.endOffset &&
                                range.startContainer.nextElementSibling.classList.contains(classes.CLS_AUDIOWRAP)) {
                                detach(range.startContainer.nextElementSibling);
                                this.isAudioRemoved = true;
                            }
                        }
                    }
                    else if (range.startContainer.nodeType === 1 && (range.startContainer.classList &&
                        (range.startContainer.classList.contains(classes.CLS_AUDIOWRAP) ||
                            range.startContainer.classList.contains(classes.CLS_CLICKELEM) ||
                            range.startContainer.classList.contains(classes.CLS_VID_CLICK_ELEM)))) {
                        detach(range.startContainer);
                    }
                }
                break;
            case 'insert-audio':
                if (!isNullOrUndefined(this.parent.formatter.editorManager.nodeSelection)) {
                    save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
                }
                this.openDialog(true, originalEvent, save, selectNodeEle, selectParentEle);
                originalEvent.preventDefault();
                break;
        }
        if (originalEvent.ctrlKey && originalEvent.key === 'a') {
            this.handleSelectAll();
        }
    }
    handleSelectAll() {
        const audioFocusNodes = this.parent.inputElement.querySelectorAll('.' + CLS_AUD_FOCUS);
        removeClass(audioFocusNodes, CLS_AUD_FOCUS);
    }
    openDialog(isInternal, event, selection, ele, parentEle) {
        let range;
        let save;
        let selectNodeEle;
        let selectParentEle;
        if (!isInternal && !isNOU(this.parent.formatter.editorManager.nodeSelection)) {
            range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
            selectNodeEle = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
            selectParentEle = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
        }
        else {
            save = selection;
            selectNodeEle = ele;
            selectParentEle = parentEle;
        }
        if (this.parent.editorMode === 'HTML') {
            this.insertAudio({
                args: {
                    item: { command: 'Audios', subCommand: 'Audio' },
                    originalEvent: event,
                    name: !isInternal ? 'showDialog' : null
                },
                selectNode: selectNodeEle,
                selection: save,
                selectParent: selectParentEle
            });
        }
    }
    showDialog(args) {
        if (!isNOU(args.originalEvent)) {
            this.openDialog(false, args.originalEvent);
        }
        else {
            this.openDialog(false);
        }
    }
    closeDialog() {
        if (this.dialogObj) {
            this.dialogObj.hide({ returnValue: true });
        }
    }
    deleteAudio(e, keyCode) {
        if (!this.isAudioElem(e.selectNode[0])) {
            return;
        }
        if (this.audEle) {
            if (e.selectNode[0].nodeType === 3) {
                e.selectNode[0] = this.audEle;
            }
            else if (this.isAudioElem(e.selectNode[0])) {
                e.selectNode[0] = e.selectNode[0].classList.contains(classes.CLS_AUDIOWRAP) ? e.selectNode[0] :
                    e.selectNode[0].parentElement;
            }
        }
        const args = {
            element: e.selectNode[0].querySelector('audio'),
            src: e.selectNode[0].querySelector('source').getAttribute('src')
        };
        if (this.parent.formatter.getUndoRedoStack().length === 0) {
            this.parent.formatter.saveData();
        }
        e.selection.restore();
        this.parent.formatter.process(this.parent, e.args, e.args, {
            selectNode: e.selectNode,
            subCommand: e.args.item.subCommand
        });
        this.audioRemovePost(args.src);
        if (this.quickToolObj && document.body.contains(this.quickToolObj.audioQTBar.element)) {
            this.quickToolObj.audioQTBar.hidePopup();
        }
        if (isNullOrUndefined(keyCode)) {
            this.parent.trigger(events.afterMediaDelete, args);
        }
    }
    audioRemovePost(src) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const proxy = this;
        let absoluteUrl = '';
        if (isNOU(this.parent.insertAudioSettings.removeUrl) || this.parent.insertAudioSettings.removeUrl === '') {
            return;
        }
        if (src.indexOf('http://') > -1 || src.indexOf('https://') > -1) {
            absoluteUrl = src;
        }
        else {
            absoluteUrl = new URL(src, document.baseURI).href;
        }
        this.removingAudioName = absoluteUrl.replace(/^.*[\\/]/, '');
        const xhr = new XMLHttpRequest();
        // eslint-disable-next-line @typescript-eslint/tslint/config
        xhr.addEventListener('readystatechange', function () {
            if (this.readyState === 4 && this.status === 200) {
                proxy.triggerPost(this.response);
            }
        });
        xhr.open('GET', absoluteUrl);
        xhr.responseType = 'blob';
        xhr.send();
    }
    triggerPost(response) {
        const removeUrl = this.parent.insertAudioSettings.removeUrl;
        if (isNOU(removeUrl) || removeUrl === '') {
            return;
        }
        const file = new File([response], this.removingAudioName);
        const ajax = new Ajax(removeUrl, 'POST', true, null);
        const formData = new FormData();
        formData.append('UploadFiles', file);
        ajax.send(formData);
    }
    audioClick(e) {
        if (Browser.isDevice) {
            if (this.isAudioElem(e.target)) {
                e.target.focus();
                this.isAudioClicked = true;
            }
            else {
                if (!this.parent.readonly && !this.parent.videoModule.isVideoClicked && !this.parent.imageModule.isImageClicked) {
                    this.isAudioClicked = false;
                }
            }
        }
        if (this.isAudioElem(e.target) && !this.parent.userAgentData.isSafari()) {
            this.audEle = e.target.querySelector('audio');
            e.preventDefault();
        }
    }
    onDocumentClick(e) {
        const target = e.target;
        if (isNOU(this.contentModule.getEditPanel())) {
            return;
        }
        if (this.isAudioElem(target)) {
            this.audEle = target.querySelector('audio');
        }
        if (!isNullOrUndefined(this.dialogObj) && ((
        // eslint-disable-next-line
        !closest(target, '[id=' + "'" + this.dialogObj.element.id + "'" + ']') && this.parent.toolbarSettings.enable && this.parent.getToolbarElement() &&
            !this.parent.getToolbarElement().contains(e.target)) ||
            (this.parent.getToolbarElement() && this.parent.getToolbarElement().contains(e.target) &&
                !closest(target, '#' + this.parent.getID() + '_toolbar_Audio') &&
                !target.querySelector('#' + this.parent.getID() + '_toolbar_Audio')))) {
            /* eslint-disable */
            if (e.offsetX > e.target.clientWidth || e.offsetY > e.target.clientHeight) {
            }
            else {
                this.parent.notify(events.documentClickClosedBy, { closedBy: "outside click" });
                this.dialogObj.hide({ returnValue: true });
                this.parent.isBlur = true;
                dispatchEvent(this.parent.element, 'focusout');
            }
            /* eslint-enable */
        }
        if (!this.isAudioElem(target)) {
            if (!isNOU(this.audEle) && this.audEle.style.outline !== '') {
                this.audEle.style.outline = '';
            }
            else if (!isNOU(this.prevSelectedAudEle) && this.prevSelectedAudEle.style.outline !== '') {
                this.prevSelectedAudEle.style.outline = '';
            }
        }
        if (this.parent.inlineMode.enable && target && this.dialogObj && !closest(target, '#' + this.dialogObj.element.id)) {
            this.dialogObj.hide();
        }
    }
    alignmentSelect(e) {
        const item = e.item;
        if (!document.body.contains(document.body.querySelector('.e-rte-quick-toolbar')) || item.command !== 'Audios') {
            return;
        }
        const range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
        let selectNodeEle = this.parent.formatter.editorManager.nodeSelection.getNodeCollection(range);
        if (this.audEle) {
            selectNodeEle = [this.audEle];
        }
        const args = { args: e, selectNode: selectNodeEle };
        if (this.parent.formatter.getUndoRedoStack().length === 0) {
            this.parent.formatter.saveData();
        }
        switch (item.subCommand) {
            case 'Inline':
                this.inline(args);
                break;
            case 'Break':
                this.break(args);
                break;
        }
        if (this.quickToolObj && document.body.contains(this.quickToolObj.audioQTBar.element)) {
            this.quickToolObj.audioQTBar.hidePopup();
            removeClass([selectNodeEle[0]], CLS_AUD_FOCUS);
        }
    }
    break(e) {
        if (e.selectNode[0].nodeName !== 'AUDIO') {
            return;
        }
        const subCommand = (e.args.item && e.args.item.subCommand) ?
            e.args.item.subCommand : 'Break';
        this.parent.formatter.process(this.parent, e.args, e.args.originalEvent, { selectNode: e.selectNode, subCommand: subCommand });
    }
    inline(e) {
        if (e.selectNode[0].nodeName !== 'AUDIO') {
            return;
        }
        const subCommand = (e.args.item && e.args.item.subCommand) ?
            e.args.item.subCommand : 'Inline';
        this.parent.formatter.process(this.parent, e.args, e.args.originalEvent, { selectNode: e.selectNode, subCommand: subCommand });
    }
    editAreaClickHandler(e) {
        if (this.parent.readonly) {
            this.hideAudioQuickToolbar();
            return;
        }
        const args = e.args;
        const target = args.target;
        const showOnRightClick = this.parent.quickToolbarSettings.showOnRightClick;
        if (this.parent.quickToolbarModule && this.parent.quickToolbarModule.audioQTBar) {
            this.quickToolObj = this.parent.quickToolbarModule;
        }
        if (args.which === 2 || (showOnRightClick && args.which === 1) || (!showOnRightClick && args.which === 3)) {
            if ((showOnRightClick && args.which === 1) && !isNullOrUndefined(target) &&
                this.isAudioElem(target)) {
                this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument());
                this.parent.formatter.editorManager.nodeSelection.setSelectionContents(this.contentModule.getDocument(), target);
            }
            if (this.isAudioElem(target) && target.querySelector('audio')) {
                target.querySelector('audio').style.outline = '2px solid #4a90e2';
            }
            return;
        }
        if (this.parent.editorMode === 'HTML' && this.parent.quickToolbarModule && this.parent.quickToolbarModule.audioQTBar) {
            this.contentModule = this.rendererFactory.getRenderer(RenderType.Content);
            if (this.isAudioElem(target) && this.parent.quickToolbarModule) {
                this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument());
                this.parent.formatter.editorManager.nodeSelection.setSelectionContents(this.contentModule.getDocument(), target);
                if (isIDevice()) {
                    this.parent.notify(events.selectionSave, e);
                }
                this.showAudioQuickToolbar({ args: args, type: 'Audios', elements: [args.target] });
            }
            else {
                this.hideAudioQuickToolbar();
            }
        }
    }
    isAudioElem(target) {
        if (target && target.nodeType !== 3 && target.nodeName !== 'BR' && (target.classList &&
            (target.classList.contains(classes.CLS_AUDIOWRAP) || target.classList.contains('e-rte-audio') || target.classList.contains(classes.CLS_CLICKELEM)))) {
            return true;
        }
        else {
            return false;
        }
    }
    showAudioQuickToolbar(e) {
        if (e.type !== 'Audios' || isNullOrUndefined(this.parent.quickToolbarModule)
            || isNullOrUndefined(this.parent.quickToolbarModule.audioQTBar) || isNullOrUndefined(e.args)) {
            return;
        }
        this.quickToolObj = this.parent.quickToolbarModule;
        let target = e.elements;
        [].forEach.call(e.elements, (element, index) => {
            if (index === 0) {
                target = element;
            }
        });
        if (this.isAudioElem(target)) {
            const audioElem = target.tagName === 'AUDIO' ? target : target.querySelector('audio');
            addClass([audioElem], [CLS_AUD_FOCUS]);
            audioElem.style.outline = '2px solid #4a90e2';
            this.audEle = audioElem;
        }
        if (this.parent.quickToolbarModule.audioQTBar) {
            if (e.isNotify) {
                this.showPopupTime = setTimeout(() => {
                    this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument());
                    this.parent.formatter.editorManager.nodeSelection.setSelectionContents(this.contentModule.getDocument(), target);
                    this.quickToolObj.audioQTBar.showPopup(target, e.args);
                }, this.parent.element.dataset.rteUnitTesting === 'true' ? 0 : 400);
            }
            else {
                this.quickToolObj.audioQTBar.showPopup(target, e.args);
            }
        }
    }
    hideAudioQuickToolbar() {
        if (!isNullOrUndefined(this.contentModule.getEditPanel().querySelector('.' + CLS_AUD_FOCUS))) {
            removeClass([this.contentModule.getEditPanel().querySelector('.' + CLS_AUD_FOCUS)], CLS_AUD_FOCUS);
            if (!isNOU(this.audEle)) {
                this.audEle.style.outline = '';
            }
            if (this.quickToolObj && this.quickToolObj.audioQTBar && document.body.contains(this.quickToolObj.audioQTBar.element)) {
                this.quickToolObj.audioQTBar.hidePopup();
            }
        }
    }
    insertingAudio(e) {
        this.insertAudio(e);
        if (!isNullOrUndefined(this.dialogObj)) {
            this.dialogObj.element.style.maxHeight = 'inherit';
            const dialogContent = this.dialogObj.element.querySelector('.e-audio-content');
            if (!isNullOrUndefined(this.parent.insertAudioSettings.path) || this.parent.editorMode === 'HTML') {
                document.getElementById(this.rteID + '_insertAudio').focus();
            }
            else {
                dialogContent.querySelector('.e-audio-url').focus();
            }
        }
    }
    clearDialogObj() {
        if (this.uploadObj && !this.uploadObj.isDestroyed) {
            this.uploadObj.destroy();
            detach(this.uploadObj.element);
            this.uploadObj = null;
        }
        if (this.button && !this.button.isDestroyed) {
            this.button.destroy();
            detach(this.button.element);
            this.button = null;
        }
        if (this.dialogObj && !this.dialogObj.isDestroyed) {
            if (!isNOU(this.inputUrl)) {
                EventHandler.remove(this.inputUrl, 'input', this.inputUrlHandler);
                this.inputUrl = null;
            }
            this.dialogObj.destroy();
            detach(this.dialogObj.element);
            this.dialogObj = null;
        }
    }
    insertAudio(e) {
        if (this.dialogObj) {
            this.dialogObj.hide({ returnValue: true });
            return;
        }
        const audioDialog = this.parent.createElement('div', { className: 'e-rte-audio-dialog', id: this.rteID + '_audio' });
        this.parent.rootContainer.appendChild(audioDialog);
        const audioInsert = this.i10n.getConstant('dialogInsert');
        const audiolinkCancel = this.i10n.getConstant('dialogCancel');
        const audioHeader = this.i10n.getConstant('audioHeader');
        const selection = e.selection;
        const selectObj = { selfAudio: this, selection: e.selection, args: e.args, selectParent: e.selectParent };
        const dialogModel = {
            header: audioHeader,
            cssClass: classes.CLS_RTE_ELEMENTS,
            enableRtl: this.parent.enableRtl,
            locale: this.parent.locale,
            showCloseIcon: true, closeOnEscape: true, width: (Browser.isDevice) ? '290px' : '340px',
            isModal: Browser.isDevice,
            position: { X: 'center', Y: (Browser.isDevice) ? 'center' : 'top' },
            buttons: [{
                    click: this.insertAudioUrl.bind(selectObj),
                    buttonModel: { content: audioInsert, cssClass: 'e-flat e-insertAudio', isPrimary: true, disabled: true }
                },
                {
                    click: (e) => {
                        this.cancelDialog(e);
                    },
                    buttonModel: { cssClass: 'e-flat e-cancel', content: audiolinkCancel }
                }],
            target: (Browser.isDevice) ? document.body : this.parent.element,
            animationSettings: { effect: 'None' },
            close: (event) => {
                if (this.isAudioUploaded) {
                    if (this.dialogObj.element.querySelector('.e-file-abort-btn')) {
                        this.dialogObj.element.querySelector('.e-file-abort-btn').click();
                    }
                    else {
                        this.uploadObj.remove();
                    }
                }
                this.parent.isBlur = false;
                if (event && !isNOU(event.event) && event.event.returnValue) {
                    if (this.parent.editorMode === 'HTML') {
                        selection.restore();
                    }
                }
                this.clearDialogObj();
                this.dialogRenderObj.close(event);
            }
        };
        const dialogContent = this.parent.createElement('div', { className: 'e-audio-content' });
        if (!isNullOrUndefined(this.parent.insertAudioSettings.path) || this.parent.editorMode === 'HTML') {
            dialogContent.appendChild(this.audioUpload(e));
        }
        const linkHeader = this.parent.createElement('div', { className: 'e-audioheader' });
        const linkHeaderText = this.i10n.getConstant('audioLinkHeader');
        if (this.parent.editorMode === 'HTML') {
            linkHeader.innerHTML = linkHeaderText;
        }
        dialogContent.appendChild(linkHeader);
        dialogContent.appendChild(this.audioUrlPopup(e));
        if (e.selectNode && e.selectNode[0].nodeType === 1 && this.isAudioElem(e.selectNode[0])) {
            dialogModel.header = this.parent.localeObj.getConstant('editAudioHeader');
            dialogModel.content = dialogContent;
        }
        else {
            dialogModel.content = dialogContent;
        }
        this.dialogObj = this.dialogRenderObj.render(dialogModel);
        this.dialogObj.createElement = this.parent.createElement;
        this.dialogObj.appendTo(audioDialog);
        if (e.selectNode && e.selectNode[0].nodeType === 1 && this.isAudioElem(e.selectNode[0]) && (e.name === 'insertAudio')) {
            this.dialogObj.element.querySelector('.e-insertAudio').textContent = this.parent.localeObj.getConstant('dialogUpdate');
        }
        audioDialog.style.maxHeight = 'inherit';
        if (this.quickToolObj) {
            if (this.quickToolObj.audioQTBar && document.body.contains(this.quickToolObj.audioQTBar.element)) {
                this.quickToolObj.audioQTBar.hidePopup();
            }
            if (this.quickToolObj.inlineQTBar && document.body.contains(this.quickToolObj.inlineQTBar.element)) {
                this.quickToolObj.inlineQTBar.hidePopup();
            }
            if (this.quickToolObj.textQTBar && this.parent.element.ownerDocument.body.contains(this.quickToolObj.textQTBar.element)) {
                this.quickToolObj.textQTBar.hidePopup();
            }
        }
    }
    audioUrlPopup(e) {
        const audioUrl = this.parent.createElement('div', { className: 'audioUrl' });
        const placeUrl = this.i10n.getConstant('audioUrl');
        this.inputUrl = this.parent.createElement('input', {
            className: 'e-input e-audio-url',
            attrs: { placeholder: placeUrl, spellcheck: 'false', 'aria-label': this.i10n.getConstant('audioLinkHeader') }
        });
        EventHandler.add(this.inputUrl, 'input', this.inputUrlHandler, this);
        if (e.selectNode && this.isAudioElem(e.selectNode[0])) {
            const regex = new RegExp(/([^\S]|^)(((https?:\/\/)|(www\.))(\S+))/gi);
            const sourceElement = e.selectNode[0].querySelector('source');
            this.inputUrl.value = sourceElement.src.match(regex) ? sourceElement.src : '';
        }
        audioUrl.appendChild(this.inputUrl);
        return audioUrl;
    }
    onInputUrl() {
        if (!isNOU(this.inputUrl)) {
            if (this.inputUrl.value.length === 0) {
                this.dialogObj.getButtons(0).element.disabled = true;
            }
            else {
                this.dialogObj.getButtons(0).element.removeAttribute('disabled');
            }
        }
    }
    audioUpload(e) {
        let save;
        let selectParent;
        // eslint-disable-next-line
        const proxy = this;
        const iframe = proxy.parent.iframeSettings.enable;
        if (proxy.parent.editorMode === 'HTML' && (!iframe && isNullOrUndefined(closest(e.selection.range.startContainer.parentNode, '[id='
            // eslint-disable-next-line
            + "'" + this.parent.contentModule.getPanel().id + "'" + ']'))
            || (iframe && !hasClass(e.selection.range.startContainer.parentNode.ownerDocument.querySelector('body'), 'e-lib')))) {
            this.contentModule.getEditPanel().focus();
            const range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
            save = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
            selectParent = this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
        }
        else {
            save = e.selection;
            selectParent = e.selectParent;
        }
        const uploadParentEle = this.parent.createElement('div', { className: 'e-aud-uploadwrap e-droparea' });
        const deviceAudioUpMsg = this.i10n.getConstant('audioDeviceUploadMessage');
        const audioUpMsg = this.i10n.getConstant('audioUploadMessage');
        const span = this.parent.createElement('span', { className: 'e-droptext' });
        const spanMsg = this.parent.createElement('span', {
            className: 'e-rte-upload-text', innerHTML: ((Browser.isDevice) ? deviceAudioUpMsg : audioUpMsg)
        });
        span.appendChild(spanMsg);
        const btnEle = this.parent.createElement('button', {
            className: 'e-browsebtn', id: this.rteID + '_insertAudio', attrs: { autofocus: 'true', type: 'button' }
        });
        span.appendChild(btnEle);
        uploadParentEle.appendChild(span);
        const browserMsg = this.i10n.getConstant('browse');
        this.button = new Button({ content: browserMsg, enableRtl: this.parent.enableRtl });
        this.button.isStringTemplate = true;
        this.button.createElement = this.parent.createElement;
        this.button.appendTo(btnEle);
        const btnClick = (Browser.isDevice) ? span : btnEle;
        EventHandler.add(btnClick, 'click', this.fileSelect, this);
        const uploadEle = this.parent.createElement('input', {
            id: this.rteID + '_upload', attrs: { type: 'File', name: 'UploadFiles' }
        });
        uploadParentEle.appendChild(uploadEle);
        let fileName;
        let selectArgs;
        this.uploadObj = new Uploader({
            asyncSettings: { saveUrl: this.parent.insertAudioSettings.saveUrl, removeUrl: this.parent.insertAudioSettings.removeUrl },
            dropArea: span, multiple: false, enableRtl: this.parent.enableRtl,
            allowedExtensions: this.parent.insertAudioSettings.allowedTypes.toString(),
            maxFileSize: this.parent.insertAudioSettings.maxFileSize,
            selected: (e) => {
                proxy.isAudioUploaded = true;
                selectArgs = e;
                this.parent.trigger(events.fileSelected, selectArgs, (selectArgs) => {
                    if (!selectArgs.cancel) {
                        if (isNOU(selectArgs.filesData[0])) {
                            return;
                        }
                        this.checkExtension(selectArgs.filesData[0]);
                        fileName = selectArgs.filesData[0].name;
                        if (this.parent.editorMode === 'HTML' && isNullOrUndefined(this.parent.insertAudioSettings.path)) {
                            const reader = new FileReader();
                            // eslint-disable-next-line
                            reader.addEventListener('load', (e) => {
                                const url = this.parent.insertAudioSettings.saveFormat === 'Base64' ? reader.result :
                                    URL.createObjectURL(convertToBlob(reader.result));
                                proxy.uploadUrl = {
                                    url: url, selection: save, fileName: fileName,
                                    selectParent: selectParent
                                };
                                if (!isNOU(proxy.inputUrl)) {
                                    proxy.inputUrl.setAttribute('disabled', 'true');
                                }
                                if (isNullOrUndefined(proxy.parent.insertAudioSettings.saveUrl) && this.isAllowedTypes
                                    && !isNullOrUndefined(this.dialogObj)) {
                                    this.dialogObj.getButtons(0).element.removeAttribute('disabled');
                                }
                            });
                            reader.readAsDataURL(selectArgs.filesData[0].rawFile);
                        }
                    }
                });
            },
            beforeUpload: (args) => {
                this.parent.trigger(events.beforeFileUpload, args);
            },
            uploading: (e) => {
                if (!this.parent.isServerRendered) {
                    this.parent.trigger(events.fileUploading, e);
                }
            },
            success: (e) => {
                this.parent.trigger(events.fileUploadSuccess, e, (e) => {
                    if (!isNullOrUndefined(this.parent.insertAudioSettings.path)) {
                        const url = this.parent.insertAudioSettings.path + e.file.name;
                        // eslint-disable-next-line
                        const value = { url: url, selection: save };
                        proxy.uploadUrl = {
                            url: url, selection: save, fileName: fileName, selectParent: selectParent
                        };
                        proxy.inputUrl.setAttribute('disabled', 'true');
                    }
                    if (e.operation === 'upload' && !isNullOrUndefined(this.dialogObj)) {
                        this.dialogObj.getButtons(0).element.removeAttribute('disabled');
                    }
                });
            },
            failure: (e) => {
                this.parent.trigger(events.fileUploadFailed, e);
            },
            removing: () => {
                // eslint-disable-next-line
                this.parent.trigger(events.fileRemoving, e, (e) => {
                    proxy.isAudioUploaded = false;
                    this.dialogObj.getButtons(0).element.disabled = true;
                    proxy.inputUrl.removeAttribute('disabled');
                    if (proxy.uploadUrl) {
                        proxy.uploadUrl.url = '';
                    }
                });
            }
        });
        this.uploadObj.isStringTemplate = true;
        this.uploadObj.createElement = this.parent.createElement;
        this.uploadObj.appendTo(uploadEle);
        return uploadParentEle;
    }
    checkExtension(e) {
        if (this.uploadObj.allowedExtensions) {
            if (this.uploadObj.allowedExtensions.toLocaleLowerCase().indexOf(('.' + e.type).toLocaleLowerCase()) === -1) {
                this.dialogObj.getButtons(0).element.setAttribute('disabled', 'disabled');
                this.isAllowedTypes = false;
            }
            else {
                this.isAllowedTypes = true;
            }
        }
    }
    fileSelect() {
        this.dialogObj.element.getElementsByClassName('e-file-select-wrap')[0].querySelector('button').click();
        return false;
    }
    dragEnter(e) {
        e.preventDefault();
    }
    dragOver(e) {
        // Early exit: missing event/dataTransfer or already handled by another listener.
        if (!e || !e.dataTransfer || e.defaultPrevented) {
            return;
        }
        const dataTransfer = e.dataTransfer;
        const items = dataTransfer.items;
        const item = (items && items.length) ? items[0] : undefined;
        const mimeType = (items && items.length) ? (items[0].type || '') : '';
        // Empty MIME: block with forbidden cursor and stop propagation
        if (!mimeType) {
            // preventDefault() marks this element as a valid drop target so dropEffect is applied.
            e.preventDefault();
            dataTransfer.dropEffect = 'none';
            e.stopImmediatePropagation();
            return true;
        }
        // Only handle audio
        if (!mimeType.startsWith('audio/')) {
            return;
        }
        // configured allowed extensions
        const allowedTypes = this.parent.insertAudioSettings.allowedTypes || [];
        const allowedExts = new Set(allowedTypes.map((type) => (type || '').toLowerCase()));
        //Decide acceptability for this drag
        let canAccept = false;
        if (item && item.kind === 'file') {
            const mime = (item.type || '').toLowerCase();
            if (mime && mime.startsWith('audio/')) {
                const ext = this.getAudioExtensionFromMime(mime);
                canAccept = !!(ext && allowedExts.has('.' + ext));
            }
        }
        // preventDefault() marks this element as a valid drop target so dropEffect is applied.
        if (!canAccept) {
            e.preventDefault();
        }
        // set dropeffect
        dataTransfer.dropEffect = canAccept ? 'copy' : 'none';
        // Prevents subsequent dragOver listeners from running and altering the dropEffect.
        e.stopImmediatePropagation();
        // EdgeHTML compatibility: ensure drop is permitted for file/audio drags.
        if (Browser.info.name === 'edge' && dataTransfer && ((dataTransfer.items && dataTransfer.items[0].type && dataTransfer.items[0].type.split('/')[0] === 'audio') ||
            (dataTransfer.types && dataTransfer.types[0] === 'Files'))) {
            e.preventDefault();
        }
        else {
            return true;
        }
    }
    getAudioExtensionFromMime(mimeType) {
        if (!mimeType) {
            return null;
        }
        const lower = mimeType.toLowerCase().trim();
        if (!lower.startsWith('audio/')) {
            return null;
        }
        // Extract subtype after "audio/"
        let subtype = lower.slice('audio/'.length);
        // Drop parameters like "; codecs=opus"
        const paramsIdx = subtype.indexOf(';');
        if (paramsIdx !== -1) {
            // Strip any MIME parameters (e.g., "; codecs=...") and keep only the raw subtype for extension matching
            subtype = subtype.slice(0, paramsIdx).trim();
        }
        // Map MIME subtypes to their common file extensions when names differ
        const alias = new Map([
            ['mpeg', 'mp3'],
            ['x-ms-wma', 'wma'],
            ['x-wav', 'wav'],
            ['x-m4a', 'm4a'],
            ['x-aac', 'aac'],
            ['x-flac', 'flac'],
            ['x-ms-wax', 'wax'],
            ['3gpp', '3gp'] // audio/3gpp → 3gp
        ]);
        // Prefer the alias when available; otherwise use the subtype (or null if empty)
        const mapped = alias.get(subtype);
        return (mapped != null) ? mapped : (subtype || null);
    }
    /**
     * Used to set range When drop an audio
     *
     * @param {MediaDropEventArgs} args - specifies the audio arguments.
     * @returns {void}
     */
    dragDrop(args) {
        if (args.dataTransfer.files.length > 0 && args.dataTransfer.files[0].type.startsWith('audio')) {
            this.parent.trigger(events.beforeMediaDrop, args, (e) => {
                const isAudioOrFileDrop = e.dataTransfer.files.length > 0;
                if (!e.cancel && isAudioOrFileDrop) {
                    if (closest(e.target, '#' + this.parent.getID() + '_toolbar') ||
                        this.parent.inputElement.contentEditable === 'false') {
                        e.preventDefault();
                        return;
                    }
                    e.preventDefault();
                    let range;
                    if (this.contentModule.getDocument().caretRangeFromPoint) {
                        range = this.contentModule.getDocument().caretRangeFromPoint(e.clientX, e.clientY);
                    }
                    else if ((e.rangeParent)) {
                        range = this.contentModule.getDocument().createRange();
                        range.setStart(e.rangeParent, e.rangeOffset);
                    }
                    else {
                        range = this.getDropRange(e.clientX, e.clientY);
                    }
                    this.parent.notify(events.selectRange, { range: range });
                    const uploadArea = this.parent.element.querySelector('.' + classes.CLS_DROPAREA);
                    if (uploadArea) {
                        return;
                    }
                    this.insertDragAudio(e);
                }
                else {
                    if (isAudioOrFileDrop) {
                        e.preventDefault();
                    }
                }
            });
        }
    }
    /**
     * Used to calculate range on internet explorer
     *
     * @param {number} x - specifies the x range.
     * @param {number} y - specifies the y range.
     * @returns {void}
     */
    getDropRange(x, y) {
        const startRange = this.contentModule.getDocument().createRange();
        this.parent.formatter.editorManager.nodeSelection.setRange(this.contentModule.getDocument(), startRange);
        const elem = this.contentModule.getDocument().elementFromPoint(x, y);
        const startNode = (elem.childNodes.length > 0 ? elem.childNodes[0] : elem);
        let startCharIndexCharacter = 0;
        if (this.parent.inputElement.firstChild.innerHTML === '<br>') {
            startRange.setStart(startNode, startCharIndexCharacter);
            startRange.setEnd(startNode, startCharIndexCharacter);
        }
        else {
            let rangeRect;
            do {
                startCharIndexCharacter++;
                startRange.setStart(startNode, startCharIndexCharacter);
                startRange.setEnd(startNode, startCharIndexCharacter + 1);
                rangeRect = startRange.getBoundingClientRect();
            } while (rangeRect.left < x && startCharIndexCharacter < startNode.length - 1);
        }
        return startRange;
    }
    insertDragAudio(e) {
        e.preventDefault();
        const activePopupElement = this.parent.element.querySelector('' + classes.CLS_POPUP_OPEN);
        this.parent.notify(events.drop, { args: e });
        if (activePopupElement) {
            activePopupElement.classList.add(classes.CLS_HIDE);
        }
        const actionBeginArgs = {
            requestType: 'Audios',
            name: 'AudioDragAndDrop',
            cancel: false,
            originalEvent: e
        };
        if (e.dataTransfer.files.length > 0) { // For external audio drag and drop
            if (e.dataTransfer.files.length > 1) {
                return;
            }
            const audioFiles = e.dataTransfer.files;
            const fileName = audioFiles[0].name;
            const audioType = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
            const allowedTypes = this.parent.insertAudioSettings.allowedTypes;
            for (let i = 0; i < allowedTypes.length; i++) {
                if (audioType.toLowerCase() === allowedTypes[i].toLowerCase()) {
                    if (this.parent.insertAudioSettings.saveUrl) {
                        this.onSelect(e);
                    }
                    else {
                        this.parent.trigger(events.actionBegin, actionBeginArgs, (actionBeginArgs) => {
                            if (!actionBeginArgs.cancel) {
                                const args = { args: e, text: '', file: audioFiles[0] };
                                e.preventDefault();
                                this.audioPaste(args);
                            }
                            else {
                                actionBeginArgs.originalEvent.preventDefault();
                            }
                        });
                    }
                }
            }
        }
    }
    onSelect(args) {
        const range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
        const selection = this.parent.formatter.editorManager.nodeSelection.save(range, this.parent.contentModule.getDocument());
        const file = args.dataTransfer.files[0];
        const audioCommand = {
            cssClass: (this.parent.insertAudioSettings.layoutOption === 'Inline' ? classes.CLS_AUDIOINLINE : classes.CLS_AUDIOBREAK),
            url: this.parent.insertAudioSettings.path + file.name,
            selection: selection,
            fileName: file.name.replace(/\.[a-zA-Z0-9]+$/, '')
        };
        const actionBeginArgs = {
            requestType: 'Audios',
            name: 'AudioDragAndDrop',
            cancel: false,
            originalEvent: args,
            itemCollection: audioCommand
        };
        this.parent.trigger(events.actionBegin, actionBeginArgs, (actionBeginArgs) => {
            if (!actionBeginArgs.cancel) {
                // Use formatter to create properly wrapped audio
                this.parent.formatter.process(this.parent, { item: { command: 'Audios', subCommand: 'Audio' } }, args, actionBeginArgs.itemCollection);
                // Find the inserted audio
                const range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
                const audioElement = range.commonAncestorContainer.querySelector('audio');
                if (audioElement) {
                    audioElement.style.opacity = '0.5';
                    // Set up upload for the drag-dropped audio
                    this.uploadMethod(args, audioElement);
                }
            }
            else {
                actionBeginArgs.originalEvent.preventDefault();
            }
        });
    }
    /**
     * Rendering uploader and popup for drag and drop
     *
     * @param {DragEvent} dragEvent - specifies the event.
     * @param {HTMLAudioElement} audioElement - specifies the element.
     * @returns {void}
     */
    uploadMethod(dragEvent, audioElement) {
        this.popupObj = this.popupUploaderObj.renderPopup('Audios', audioElement);
        const range = this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());
        const timeOut = dragEvent.dataTransfer.files[0].size > 1000000 ? 300 : 100;
        this.audioDragPopupTime = setTimeout(() => {
            this.popupUploaderObj.refreshPopup(audioElement, this.popupObj);
        }, timeOut);
        this.uploadObj = this.popupUploaderObj.createUploader('Audios', dragEvent, audioElement, this.popupObj.element.childNodes[0], this.popupObj);
        this.popupObj.element.querySelector('.e-rte-dialog-upload .e-file-select-wrap').style.display = 'none';
        range.selectNodeContents(audioElement);
        this.parent.formatter.editorManager.nodeSelection.setRange(this.contentModule.getDocument(), range);
    }
    audioPaste(args) {
        if (args.text.length === 0 && !isNOU(args.file)) {
            // eslint-disable-next-line
            const proxy = this;
            const reader = new FileReader();
            args.args.preventDefault();
            reader.addEventListener('load', (e) => {
                const file = args.file;
                const url = this.parent.insertAudioSettings.saveFormat === 'Base64' || !isNOU(args.callBack) ?
                    reader.result : URL.createObjectURL(convertToBlob(reader.result));
                const audioCommandArgs = {
                    cssClass: (proxy.parent.insertAudioSettings.layoutOption === 'Inline' ?
                        classes.CLS_AUDIOINLINE : classes.CLS_AUDIOBREAK),
                    url: url,
                    fileName: file.name
                };
                if (!isNOU(args.callBack)) {
                    args.callBack(audioCommandArgs);
                    return;
                }
                else {
                    proxy.parent.formatter.process(proxy.parent, { item: { command: 'Audios', subCommand: 'Audio' } }, args.args, audioCommandArgs);
                }
            });
            reader.readAsDataURL(args.file);
        }
    }
    // eslint-disable-next-line
    cancelDialog(e) {
        this.parent.isBlur = false;
        this.dialogObj.hide({ returnValue: true });
        if (this.isAudioUploaded) {
            this.uploadObj.removing();
        }
    }
    // eslint-disable-next-line
    insertAudioUrl(e) {
        const proxy = this.selfAudio;
        //let audioSelectParent: Node = proxy.uploadUrl.selectParent[0];
        proxy.isAudioUploaded = false;
        const url = proxy.inputUrl.value;
        if (proxy.parent.formatter.getUndoRedoStack().length === 0) {
            proxy.parent.formatter.saveData();
        }
        if (!isNullOrUndefined(proxy.uploadUrl) && proxy.uploadUrl.url !== '') {
            proxy.uploadUrl.cssClass = (proxy.parent.insertAudioSettings.layoutOption === 'Inline' ?
                classes.CLS_AUDIOINLINE : classes.CLS_AUDIOBREAK);
            proxy.dialogObj.hide({ returnValue: false });
            if (proxy.dialogObj !== null) {
                return;
            }
            proxy.parent.formatter.process(proxy.parent, this.args, this.args.originalEvent, proxy.uploadUrl);
            proxy.uploadUrl.url = '';
        }
        else if (url !== '') {
            if (proxy.parent.editorMode === 'HTML' && isNullOrUndefined(closest(
            // eslint-disable-next-line
            this.selection.range.startContainer.parentNode, '[id=' + "'" + proxy.contentModule.getPanel().id + "'" + ']')) && !(proxy.parent.iframeSettings.enable)) {
                proxy.contentModule.getEditPanel().focus();
                const range = proxy.parent.formatter.editorManager.nodeSelection.getRange(proxy.contentModule.getDocument());
                this.selection = proxy.parent.formatter.editorManager.nodeSelection.save(range, proxy.contentModule.getDocument());
                this.selectParent = proxy.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(range);
            }
            const name = proxy.parent.editorMode === 'HTML' ? url.split('/')[url.split('/').length - 1] : '';
            const value = {
                cssClass: (proxy.parent.insertAudioSettings.layoutOption === 'Inline' ? classes.CLS_AUDIOINLINE : classes.CLS_AUDIOBREAK),
                url: url, selection: this.selection, fileName: name,
                selectParent: this.selectParent
            };
            proxy.dialogObj.hide({ returnValue: false });
            if (proxy.dialogObj !== null) {
                return;
            }
            proxy.parent.formatter.process(proxy.parent, this.args, this.args.originalEvent, value);
        }
    }
    /* eslint-disable */
    /**
     * Destroys the ToolBar.
     *
     * @method destroy
     * @returns {void}
     * @hidden
     * @deprecated
     */
    /* eslint-enable */
    destroy() {
        if (this.isDestroyed) {
            return;
        }
        this.prevSelectedAudEle = undefined;
        if (this.showPopupTime) {
            clearTimeout(this.showPopupTime);
            this.showPopupTime = null;
        }
        this.removeEventListener();
        this.clearDialogObj();
        this.isDestroyed = true;
        this.onDocumentClickBoundFn = null;
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     * @hidden
     */
    getModuleName() {
        return 'audio';
    }
}
